import { useEffect } from "react";
import { FooterComponent, HeaderComponent } from "../../common";
import { FeaturesComponent } from "../Components/FeaturesComponent";
import { PresentationComponent } from "../Components/PresentationComponent";
import { IconCloudComponent } from "../Components/IconCloudComponent";

export const InicioPage = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "./js/animations.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="body-wrap boxed-container">
      <HeaderComponent />
      <main>
        <PresentationComponent />
        <FeaturesComponent />
        <IconCloudComponent />
      </main>
      <FooterComponent />
    </div>
  );
};
